// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GP9tydRWq8JF01uHL9Xx{grid-gap:12px;grid-template-columns:repeat(auto-fill,238px);justify-content:center;display:grid;position:relative}@media (min-width:1440px){.GP9tydRWq8JF01uHL9Xx{grid-template-columns:repeat(4,238px);justify-content:start}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `GP9tydRWq8JF01uHL9Xx`
};
export default ___CSS_LOADER_EXPORT___;
